export class ChartBoardOptions {
    constructor(public echartsConfiguration = true) {
    }
}
